// Promise.withResolvers polyfill for Safari < 17
if (typeof (Promise as any).withResolvers !== "function")
  (Promise as any).withResolvers = function <T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;

    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });

    return { promise, resolve, reject };
  };

// URL.parse polyfill for Safari < 17
if (typeof (URL as any).parse !== "function")
  (URL as any).parse = (url: string, base?: string | URL): URL | null => {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
